import React from 'react';
import { Bar, BarChart, ResponsiveContainer } from 'recharts';

interface MetricCardProps {
  label: string;
  value: string | number;
  detail?: string;
  accent?: string;
  accented?: boolean;
  sparkValues?: number[];
  loading?: boolean;
  size?: 'compact' | 'large';
}

export function MetricCard({ label, value, detail, accent, accented, sparkValues, loading, size = 'compact' }: MetricCardProps) {
  const series = (sparkValues || []).map((item, index) => ({ index, value: item }));

  return (
    <article className={`metric-card metric-card--${size}${accented ? ' metric-card--accented' : ''}${loading ? ' metric-card--loading' : ''}`}>
      <div className="metric-card__header">
        <span className="metric-card__label">{label}</span>
        {accent ? <span className="metric-card__chip" style={{ background: accent }} /> : null}
      </div>

      {loading ? (
        <>
          <div className="skeleton-line skeleton-line--xl" />
          <div className="skeleton-line" />
        </>
      ) : (
        <>
          <div className="metric-card__value-wrap">
            <div className={`metric-card__value${accented ? ' metric-card__value--accented' : ''}`}>{value ?? 0}</div>
          </div>
          {detail ? <div className="metric-card__detail">{detail}</div> : null}
        </>
      )}

      {size === 'large' && !loading ? (
        <div className="metric-card__spark">
          <ResponsiveContainer width="100%" height={72}>
            <BarChart data={series}>
              <Bar dataKey="value" fill="var(--accent-green)" radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : null}
    </article>
  );
}
